<template>
  <div class='platForm' >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Index',
  mounted () {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      this.$router.push({path: '/mobile'})
      // this.$router.push({path: '/pc'})
    } else {
      this.$router.push({path: '/pc'})
    }
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, true)
  },
  data () {
    return {
      data: ''
    }
  },
  methods: {
    handleScroll (e) {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 50) {} else {}
    }
  }
}
</script>
<style scoped>
.platForm{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue